import { render, staticRenderFns } from "./vip.vue?vue&type=template&id=afaeb2dc&scoped=true&"
import script from "./vip.vue?vue&type=script&lang=js&"
export * from "./vip.vue?vue&type=script&lang=js&"
import style0 from "./vip.vue?vue&type=style&index=0&id=afaeb2dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afaeb2dc",
  null
  
)

export default component.exports